<script lang="ts" setup>
import { buildMeta } from '~~/utils/meta-builder';
useHead(buildMeta({ key:'careers',  follow: true })) 
const config = useRuntimeConfig();
const jobsEmail = ref(`<a class="text-link" href="mailto:${config.public.email.jobs}">${config.public.email.jobs}</a>`);
</script>
<template>

    <div class="w-full relative ">
        <div class="w-full h-full absolute -z-10">
            <div class="header w-full h-full overflow-x-hidden">
              <svg class="absolute right-0" width="688" height="780" viewBox="0 0 688 780" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112467)">
                <circle cx="522.5" cy="257.5" r="278.5" fill="#FFA5A5" fill-opacity="0.79"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112467" x="0" y="-265" width="1045" height="1045" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="122" result="effect1_foregroundBlur_14818_112467"/>
                </filter>
                </defs>
              </svg>

               <svg class="absolute" width="377" height="565" viewBox="0 0 377 565" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112466)">
                <circle cx="9" cy="197" r="194" fill="#B5FBFF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112466" x="-359" y="-171" width="736" height="736" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="87" result="effect1_foregroundBlur_14818_112466"/>
                </filter>
                </defs>
              </svg>

              <svg class="mx-auto" width="1131" height="612" viewBox="0 0 1131 612" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112468)">
                <circle cx="590" cy="22" r="206" fill="#A864FF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112468" x="0" y="-568" width="1180" height="1180" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="192" result="effect1_foregroundBlur_14818_112468"/>
                </filter>
                </defs>
              </svg>

            </div>
        </div>
        <Header theme="light" />
    
        <div class="flex flex-col max-w-screen-lg gap-10 px-10 pt-10 mb-32 mx-auto justify-center text-[#290B50]">
          
            <div class="flex flex-col flex-1 pb-20 md:w-3/4">
                <h1 class="text-6xl lg:text-7xl font-owners font-bold pb-6 pt-2" v-html="$t('careers.headline')"></h1>
                <p class="text-black/75 text-2xl mt-10" v-html="$t('careers.body')"></p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-20">
                <div class="">
                    <h3 class="text-xl font-owner font-bold">{{$t('careers.benefits.unique.title')}}</h3>
                    <p class="text-black/75 text-lg pb-6 pt-3 col-span-2" v-html="$t('careers.benefits.unique.body')"></p>
                </div>
                <div class="">
                    <h3 class="text-xl font-owner font-bold">{{$t('careers.benefits.value.title')}}</h3>
                    <p class="text-black/75 text-lg pb-6 pt-3 col-span-2" v-html="$t('careers.benefits.value.body')"></p>
                </div>
                <div class="">
                    <h3 class="text-xl font-owner font-bold">{{$t('careers.benefits.grow.title')}}</h3>
                    <p class="text-black/75 text-lg pb-6 pt-3 col-span-2" v-html="$t('careers.benefits.grow.body')"></p>
                </div>
                <div class="">
                    <h3 class="text-xl font-owner font-bold">{{$t('careers.benefits.lifestyle.title')}}</h3>
                    <p class="text-black/75 text-lg pb-6 pt-3 col-span-2" v-html="$t('careers.benefits.lifestyle.body')"></p>
                </div>
            </div>

            <h2 class="text-5xl font-bold font-owners mt-10" v-html="$t('careers.positions.title')"></h2>
            <p class="text-xl" v-html="$t('careers.positions.body', {'email': jobsEmail})"></p>
<!--             
            <div v-for="item in positions" class="w-full" :key="item.id">
              <h3 class="font-owners font-bold text-3xl">{{item.title}}</h3>
              <p class="text-xl">{{item.body}}</p>
            </div> -->

        </div>

    <Footer />
   
  </div>
</template>

